import { ReactNode, Suspense, forwardRef, useImperativeHandle, useState } from 'react';
import { Presenter } from './index';
import React from 'react';

export type DefaultPresenterProps = React.PropsWithChildren & { fallback?: ReactNode; className?: string };

const DefaultPresenter = forwardRef<Presenter, DefaultPresenterProps>(function DefaultPresenter({ children, fallback }: DefaultPresenterProps, ref) {
    const [show, setShow] = useState(false);
    useImperativeHandle(
        ref,
        () => ({
            open: async () => {
                if (show) {
                    return;
                }
                setShow(true);
            },
            close: async () => {
                if (!show) {
                    return;
                }
                setShow(false);
            },
        }),
        [show]
    );
    return show ? <Suspense fallback={fallback}> {children}</Suspense> : <></>;
});

export default DefaultPresenter;
